import { useEffect, useState, useRef } from 'react'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'

export function SelectWithAreas({ list = [], onChange, label, name, value, placeholder = '', error = false, required = false, disabled = false }) {
	const [open, setOpen] = useState(false)
	const [selectedItem, setSelectedItem] = useState(null)
	const [search, setSearch] = useState('')
	const [filteredList, setFilteredList] = useState(list)

	const selectRef = useRef(null)

	useEffect(() => {
		const handleClickOutside = event => {
			if (selectRef.current && !selectRef.current.contains(event.target)) {
				setOpen(false)
			}
		}
		document.addEventListener('click', handleClickOutside)
		return () => {
			document.removeEventListener('click', handleClickOutside)
		}
	}, [])

	useEffect(() => {
		if (value) {
			const selected = list.find(item => item.id === value)
			setSelectedItem(selected)
		}
	}, [value, list])

	useEffect(() => {
		if (search) {
			const filtered = list.filter(item => item.name.toLowerCase().includes(search.toLowerCase()))
			setFilteredList(filtered)
		} else {
			setFilteredList(list)
		}
	}, [search, list])

	const handleClick = item => {
		setSelectedItem(item)
		onChange({ target: { value: item.id, name, label: item.name } })
		setOpen(false)
		setSearch('')
	}

	if (disabled) {
		return (
			<div className='tw-w-full tw-cursor-not-allowed tw-text-gray-500'>
				<div className='tw-flex tw-items-center tw-justify-between tw-p-3 border tw-border-gray-300 tw-rounded-lg tw-bg-gray-100'>
					<span className='tw-text-sm'>{placeholder}</span>
					<MdKeyboardArrowDown size={20} />
				</div>
				{label && (
					<label className='tw-text-sm tw-mt-1 tw-block'>
						{label} {required && <span className='tw-text-red-500'>*</span>}
					</label>
				)}
			</div>
		)
	}

	return (
		<div className='tw-relative tw-w-full' ref={selectRef}>
			{label && (
				<label className='tw-text-sm tw-block tw-mb-1'>
					{label} {required && <span className='tw-text-red-500'>*</span>}
				</label>
			)}
			<div
				className={`tw-flex tw-items-center tw-justify-between tw-p-3 border tw-rounded-lg ${
					error ? 'border-red-500' : 'border-gray-300 tw-bg-white hover:border-gray-400'
				}`}
				onClick={() => setOpen(!open)}
			>
				<span className='tw-text-base tw-text-gray-700'>
					{selectedItem ? (
						<div className='tw-flex tw-items-center tw-space-x-2'>
							{selectedItem.photo ? (
								<img src={selectedItem.photo} alt={selectedItem.name} className='tw-w-6 tw-h-6 tw-rounded-full' />
							) : (
								<div className='tw-w-6 tw-h-6 tw-rounded-full tw-bg-gray-300 tw-flex tw-items-center tw-justify-center tw-text-white'>
									{selectedItem.name[0]}
								</div>
							)}
							<span>{selectedItem.name}</span>
						</div>
					) : (
						placeholder
					)}
				</span>
				{!open ? <MdKeyboardArrowDown size={20} /> : <MdKeyboardArrowUp size={20} />}
			</div>
			{open && (
				<div className='tw-absolute tw-z-10 tw-bg-white tw-shadow-lg tw-rounded-lg tw-w-full tw-mt-1 tw-p-2' style={{ border: '1px solid #7A6BE8' }}>
					<div className='tw-flex tw-items-center tw-px-2 tw-bg-white tw-rounded-lg tw-h-8'>
						<input
							type='text'
							value={search}
							onChange={e => setSearch(e.target.value)}
							placeholder='Buscar colaborador...'
							className='tw-w-full tw-h-8 border-0 tw-text-sm focus:tw-outline-none'
						/>
					</div>
					<div className='tw-w-full tw-h-px tw-bg-gray-200 tw-my-2'></div>
					<div className='tw-max-h-60 tw-overflow-y-auto'>
						{filteredList.map(item => (
							<div
								key={item.id}
								onClick={() => handleClick(item)}
								className='tw-flex tw-items-center tw-p-2 tw-cursor-pointer hover:tw-bg-gray-100 tw-rounded-lg'
							>
								{item.photo ? (
									<img src={item.photo} alt={item.name} className='tw-w-6 tw-h-6 tw-rounded-full tw-mr-2' />
								) : (
									<div className='tw-w-6 tw-h-6 tw-rounded-full tw-bg-gray-300 tw-flex tw-items-center tw-justify-center tw-text-white tw-mr-2'>
										{item.name[0]}
									</div>
								)}
								<span className='tw-text-base'>
									{item.name} <span className='tw-text-gray-300 tw-ml-3'>{item.area}</span>
								</span>
							</div>
						))}
					</div>
				</div>
			)}
		</div>
	)
}
